/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskOverviewUserBreakdown } from "../funcs/riskOverviewUserBreakdown.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskUserBreakdownResult } from "../models/components/riskuserbreakdownresult.js";
import {
  GetRiskUserBreakdownRequest,
  GetRiskUserBreakdownSecurity,
} from "../models/operations/getriskuserbreakdown.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskUserBreakdownQueryData = RiskUserBreakdownResult;

export function prefetchRiskUserBreakdown(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetRiskUserBreakdownRequest,
  security?: GetRiskUserBreakdownSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskUserBreakdownQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskUserBreakdownQuery(
  client$: GramCore,
  request: GetRiskUserBreakdownRequest,
  security?: GetRiskUserBreakdownSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskUserBreakdownQueryData>;
} {
  return {
    queryKey: queryKeyRiskUserBreakdown({
      externalUserId: request.externalUserId,
      from: request.from,
      to: request.to,
      gramKey: request.gramKey,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function riskUserBreakdownQueryFn(
      ctx,
    ): Promise<RiskUserBreakdownQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskOverviewUserBreakdown(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskUserBreakdown(
  parameters: {
    externalUserId: string;
    from?: Date | undefined;
    to?: Date | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "overview", "userBreakdown", parameters];
}
